import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { WsTooltipModule } from '@web/util/ws-ui/ws-tooltip/ws-tooltip.module';
import { DwsPermissionDirectiveModule } from '@util/directives/dwsPermission/dws-permission.module';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureToggleModule } from "../../modules/feature-toggle/feature-toggle.module";
import { WsPageSubHeaderComponent } from './ws-page-subheader.component';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    WsTooltipModule,
    TranslateModule,
    DwsPermissionDirectiveModule,
    WsUiModule,
    FeatureToggleModule
],
  declarations: [WsPageSubHeaderComponent],
  exports: [WsPageSubHeaderComponent]
})
export class WsPageSubHeaderModule { }
